import { actionTypes } from '../constants';
export const addError = (payload, meta)=>({
        type: actionTypes.ADD_ERROR,
        payload,
        meta
    });
export const removeError = (payload)=>({
        type: actionTypes.REMOVE_ERROR,
        payload
    });
export const hideError = (payload)=>({
        type: actionTypes.HIDE_ERROR,
        payload
    });
export const clearErrors = (payload)=>({
        type: actionTypes.CLEAR_ERRORS,
        payload
    });
export const hideErrors = (payload)=>({
        type: actionTypes.HIDE_ERRORS,
        payload
    });
export const showErrors = (payload)=>({
        type: actionTypes.SHOW_ERRORS,
        payload
    });
export const showErrorSingle = (payload)=>({
        type: actionTypes.SHOW_ERROR_SINGLE,
        payload
    });
export const showErrorMultiple = (payload)=>({
        type: actionTypes.SHOW_ERROR_MULTIPLE,
        payload
    });
export const closeErrorSingle = (payload)=>({
        type: actionTypes.CLOSE_ERROR_SINGLE,
        payload
    });
export const closeErrorMultiple = (payload)=>({
        type: actionTypes.CLOSE_ERROR_MULTIPLE,
        payload
    });
export const deleteSent = (payload)=>({
        type: actionTypes.DELETE_SENT,
        payload
    });
export const sentSuccessfully = (payload)=>({
        type: actionTypes.SENT_SUCCESSFULLY,
        payload
    });
export const sentFailed = (payload)=>({
        type: actionTypes.SENT_FAILED,
        payload
    });
export const removeErrorSingle = (payload)=>({
        type: actionTypes.REMOVE_ERROR_SINGLE,
        payload
    });
export const showFullScreenError = (payload)=>({
        type: actionTypes.SHOW_ERROR_FULLSCREEN,
        payload
    });
